/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Llm_ProviderInputs */



/**
* | output |
* | --- |
* | "LLM Provider" |
*
* @param {Llm_ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const llm_provider = /** @type {((inputs?: Llm_ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Llm_ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fournisseur de LLM")
	if (locale === "de") return /** @type {LocalizedString} */ ("LLM-Anbieter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fornitore di LLM")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поставщик программ магистратуры в области права")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proveedor de LLM")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("法学硕士提供者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("LLM（法学修士）提供機関")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एलएलएम प्रदाता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fornecedor de LLM")
	return /** @type {LocalizedString} */ ("LLM Provider")
});